import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden architectural-lines"
      style={{
        backgroundImage: 'url(https://images.pexels.com/photos/17483870/pexels-photo-17483870.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70" />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <motion.p
            className="text-xs uppercase tracking-[0.2em] text-gold/60 mb-6"
            data-testid="hero-subtitle"
          >
            {t.hero.subtitle}
          </motion.p>

          <motion.h1
            className="text-6xl md:text-8xl lg:text-[10rem] tracking-tight leading-[0.9] text-zinc-100 font-light mb-8"
            data-testid="hero-title"
          >
            {t.hero.title1}
            <br />
            <span className="text-gold">{t.hero.title2}</span>
          </motion.h1>

          <motion.p
            className="text-base md:text-lg leading-relaxed text-zinc-400 max-w-2xl mx-auto mb-12"
            data-testid="hero-description"
          >
            {t.hero.description1}
            <br />
            {t.hero.description2}
          </motion.p>

          {/* CTA Button */}
          <motion.button
            data-testid="hero-contact-cta"
            onClick={scrollToContact}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="bg-gold text-black hover:bg-white transition-colors duration-300 px-8 md:px-12 py-4 md:py-5 uppercase tracking-widest text-xs md:text-sm font-bold"
          >
            {t.header.contactButton}
          </motion.button>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-12 left-1/2 transform -translate-x-1/2"
      >
        <div className="w-[1px] h-16 bg-gradient-to-b from-gold to-transparent" />
      </motion.div>
    </section>
  );
};

export default Hero;
